export default __webpack_public_path__ + "static/user-7fd43c8e2ea3dbee46b80a7cb87919de.png";